import { withLoginRequired } from '../../hocs/with-login-required';
import { withLayout, LAYOUT_TYPES } from '../../hocs/with-layout';
import { EducationLevelStatistic } from './education-level-statistic';

// eslint-disable-next-line max-len
const WrappedStatistics = withLoginRequired(withLayout(LAYOUT_TYPES.HEADER, EducationLevelStatistic));

export { WrappedStatistics as EducationLevelStatistic };
